<template>
  <div>
    <!-- View + Edit (+ Sil sadece dataId varsa) dropdown -->
    <template v-if="viewAction || editAction">
      <b-dropdown
        split
        :text="viewAction ? 'Görüntüle' : 'Güncelle'"
        variant="outline-primary"
        right
        size="sm"
        :disabled="disabled"
        @click="$router.push(viewAction ? viewAction : editAction)"
      >
        <template #button-content>
          <feather-icon
            :icon="viewAction ? 'EyeIcon' : 'EditIcon'"
          />
          {{ viewAction ? 'Görüntüle' : 'Güncelle' }}
        </template>
        <b-dropdown-item
          v-if="viewAction && editAction"
          :disabled="disabled"
          @click="$router.push(editAction)"
        >
          <feather-icon icon="EditIcon" />
          Güncelle
        </b-dropdown-item>
        <b-dropdown-item
          v-if="viewAction && !editAction"
          :disabled="disabled"
          @click="$router.push(viewAction)"
        >
          <feather-icon icon="EyeIcon" />
          Görüntüle
        </b-dropdown-item>
        <b-dropdown-item
          v-if="deleteAction && dataId"
          :disabled="disabled"
          @click="deleteAction(dataId)"
        >
          <feather-icon icon="XIcon" />
          <span class="align-middle ml-50">Sil</span>
        </b-dropdown-item>
      </b-dropdown>
    </template>
    <template v-else-if="editAction">
      <b-button
        :to="editAction"
        variant="outline-primary"
        size="sm"
        :disabled="disabled"
      >
        <feather-icon icon="EditIcon" />
        Güncelle
      </b-button>
    </template>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem, BButton } from 'bootstrap-vue'

export default {
  name: 'ListButtons',
  components: {
    BDropdown, BDropdownItem, BButton,
  },
  props: {
    viewAction: {
      type: String,
      required: false,
      default: null,
    },
    editAction: {
      type: String,
      required: false,
      default: null,
    },
    dataId: {
      type: Number,
      required: false,
      default: null,
    },
    deleteAction: {
      type: Function,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>

</style>
